import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class PreloaderService {
  private subject = new Subject<any>();
  public preloadStatus = false;

  sendData(message: any) {
    this.subject.next(message);
    if (message.status == true) {
      this.preloadStatus = true;
    }
  }

  clearData() {
    this.subject.next(null);
  }

  getData(): Observable<any> {
    return this.subject.asObservable();
  }
}
